
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      

      {/* Main Header */}
          <header className="bg-[#003d5c] shadow-sm sticky top-0 z-50 min-h-[20px]" style={{ backgroundImage: 'url(/images/new.png)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-2">
            <div className="flex-shrink-0">
              <Link to="/">
                <img 
                  src="/images/lagoos.png" 
                  alt="AgriWorks" 
                  className="h-20 w-auto"
                />
              </Link>
            </div>
            
            <nav className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-8 font-bold text-white hover:text-gray-200 transition-colors whitespace-nowrap">
                HOME
              </Link>
                          <Link to="/products" className="text-8 font-bold text-white hover:text-gray-200 transition-colors whitespace-nowrap">
                  PRODUCTS
                          </Link>
                          <Link to="/help-faqs" className="text-8 font-bold text-white hover:text-gray-200 transition-colors whitespace-nowrap">
                  INFORMATION
                          </Link>
              <Link to="/about-us" className="text-8 font-bold text-white hover:text-gray-200 transition-colors whitespace-nowrap">
                ABOUT US
              </Link>
              <Link to="/contact" className="text-8 font-bold text-white hover:text-gray-200 transition-colors whitespace-nowrap">
                CONTACT US
              </Link>
            </nav>

            <button className="lg:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-white/20">
            <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
              <Link to="/" className="text-sm font-bold text-white hover:text-gray-200 transition-colors">
                HOME
              </Link>
                          <Link to="/products" className="text-sm font-bold text-white hover:text-gray-200 transition-colors">
                PRODUCTS
                          </Link>
                          <Link to="/help-faqs" className="text-sm font-bold text-white hover:text-gray-200 transition-colors">
                INFORMATION
                          </Link>
              <Link to="/about-us" className="text-sm font-bold text-white hover:text-gray-200 transition-colors">
                ABOUT US
              </Link>
              <Link to="/contact" className="text-sm font-bold text-white hover:text-gray-200 transition-colors">
                CONTACT US
              </Link>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}
